'use client';

import { FC, PropsWithChildren } from 'react';
import { Portal, Drawer } from 'components/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';
import { useDealerLocatorDrawer } from '../dealer-locator-drawer-context';
import { useDealerLocatorLoader } from '../dealer-locator-loader-context';

export const DealerLocatorDrawerWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const dealerLocatorDrawer = useDealerLocatorDrawer();
  const dealerLocatorLoader = useDealerLocatorLoader();

  return (
    <Portal id={ROOT_PORTALS}>
      <Drawer
        {...dealerLocatorDrawer?.drawerProps}
        disableBackdropClick={
          dealerLocatorLoader?.isDealerLocatorLoading ||
          dealerLocatorDrawer?.drawerProps?.disableBackdropClick
        }
        hideCloseButton={
          dealerLocatorLoader?.isDealerLocatorLoading ||
          dealerLocatorDrawer?.drawerProps?.hideCloseButton
        }
        hasBackdrop={
          !dealerLocatorLoader?.isDealerLocatorLoading &&
          dealerLocatorDrawer?.drawerProps?.hasBackdrop
        }
      >
        {children}
      </Drawer>
    </Portal>
  );
};
